import React, {useReducer} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import {PlayerStats} from 'app/components/player/PlayerStats';
import {Helmet} from 'react-helmet-async';
import {string} from 'prop-types';
import {fetchPlayerRankings} from 'app/routes/player/PlayerPageActions';
import {PlayerRankingsPageReducer} from 'app/routes/player/PlayerPageReducer';
import {LoadingIndicator, LOADING_MESSAGE} from '@fupa/fupa-uikit';
import {useParams} from 'react-router';
import {useFetchData, useRestoreData} from 'app/hooks/dataHooks';

const PlayerRankingsPage = ({metaDescription, dispatchRedux}) => {
  const topValue = '0rem';

  const {restoredData} = useRestoreData('PlayerRankingsPage');
  const {playerSlug} = useParams();
  const initialState = restoredData ?? {
    isFetching: false,
    data: {},
  };
  const [state, dispatch] = useReducer(PlayerRankingsPageReducer, initialState);

  const loadData = () => fetchPlayerRankings(playerSlug, dispatchRedux)(dispatch, state);
  const {data, isFetching} = state;
  useFetchData(state, loadData, 'PlayerRankingsPage');

  const meta = [
    {name: 'description', content: 'Rankings - ' + metaDescription},
    {name: 'robots', content: 'noindex, follow'},
  ];

  const content = isFetching ? (
    <LoadingIndicator message={LOADING_MESSAGE.loadingData} bgColor={false} />
  ) : (
    <PlayerStats stats={data} />
  );

  return (
    <ContentAdDesktop top={topValue}>
      <Helmet title='Rankings - ' meta={meta} />
      {content}
    </ContentAdDesktop>
  );
};

PlayerRankingsPage.propTypes = {
  metaDescription: string.isRequired,
};

export default PlayerRankingsPage;
